var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 35,
    viewBox: "0 0 160 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8203 25.2783V9.88086H52.9838L58.2593 21.3872L63.4565 9.88086H67.4451V25.2783H64.0118V16.3209L60.0506 25.2783H56.3909L52.3789 16.3697V25.2783H48.8203Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2595 19.3161L78.3868 12.7894L75.5801 19.3161H81.2595ZM73.0121 25.2778H68.9746L75.9148 9.88037H80.8856L87.8754 25.2778H83.8901L82.5144 22.2106H74.3454L73.0121 25.2778Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4844 25.2778V9.88037H104.423V12.9591H93.0925V16.0173H102.808V19.0221H93.0925V22.1978H104.451V25.2778H89.4844Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.019 16.9507H118.868V12.9594H111.019V16.9507ZM107.359 25.2778V9.88037H119.86C121.53 9.88037 122.5 10.8315 122.5 12.4627V17.6356C122.5 18.8256 121.429 19.9013 119.353 19.9013C119.236 19.9071 119.116 19.9013 118.992 19.9013L122.631 25.2778H118.615L115.165 20.013H111.018V25.2778H107.359Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.083 25.2874H127.845C126.228 25.2874 125.449 24.3678 125.449 23.0288V21.0174H129.083V22.2087H136.805V19.0568C136.805 19.0568 129.361 19.0568 127.948 19.0568C126.534 19.0568 125.515 18.1211 125.515 16.8226V12.2514C125.515 10.8681 126.624 9.89062 127.973 9.89062C129.321 9.89062 138.098 9.89062 138.098 9.89062C139.467 9.89062 140.414 10.8957 140.414 12.349C140.414 13.8003 140.414 14.1863 140.414 14.1863H136.805V12.9693H129.083V16.0018H137.916C139.219 16.0018 140.414 16.8508 140.414 18.4852V22.8798C140.414 24.3768 139.57 25.2874 137.992 25.2874C136.414 25.2874 129.083 25.2874 129.083 25.2874Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.898 25.2864V9.8877H147.608V16.0464L154.673 9.8877H159.696L151.267 17.0405L159.999 25.2864H154.799L147.608 18.2826V25.2864H143.898Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04372 0H29.5843C31.8211 0 33.6345 1.78815 33.6345 3.99394V31.0061C33.6345 33.2119 31.8211 35 29.5843 35H4.04372C1.81045 35 2.10691e-05 33.2147 2.10691e-05 31.0125V4.00037C-0.00344577 2.94059 0.421055 1.92304 1.17977 1.17246C1.93849 0.421871 2.969 -5.51398e-06 4.04372 0Z",
    fill: "#42B0D5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1757 16.518L28.8152 8.34205L28.7956 8.31644L19.2016 12.8494L16.8341 2.66309H16.795L14.4275 12.8494L4.83345 8.31644L4.81389 8.34205L11.4534 16.518L1.85938 21.0509L1.87242 21.0829H12.5165L10.149 31.2756L10.175 31.2884L16.8145 23.1125L23.454 31.2884L23.4867 31.2692L21.1126 21.0829H31.7632L31.7697 21.0509L22.1757 16.518Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4b255e19830c20c9882ef5b9953735bf.svg";
export { ForwardRef as ReactComponent };